var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Insights") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insights"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-71",
    transform: "translate(50.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#08D6A1",
    x: 0,
    y: 139.600522,
    width: 90.2689076,
    height: 39.5718016,
    rx: 17.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#08D6A1",
    x: 433.731092,
    y: 139.600522,
    width: 90.2689076,
    height: 39.5718016,
    rx: 17.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6809691,247.848496 L101.716571,247.883657 C111.427996,247.889861 119.299114,255.760976 119.305323,265.472401 L119.308127,269.858793 C119.314342,279.579003 111.439593,287.463828 101.719384,287.470042 C101.711884,287.470047 101.704385,287.470047 101.696886,287.470042 L46.6612848,287.434881 C36.9498597,287.428676 29.0787418,279.557562 29.0725328,269.846137 L29.0697283,265.459745 C29.0635136,255.739535 36.9382624,247.85471 46.658472,247.848496 C46.665971,247.848491 46.6734701,247.848491 46.6809691,247.848496 Z",
    id: "Rectangle",
    fill: "#08D6A1",
    transform: "translate(74.188928, 267.659269) rotate(-30.000000) translate(-74.188928, -267.659269) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.303114,31.3028036 L477.338715,31.337965 C487.05014,31.3441695 494.921258,39.2152836 494.927467,48.9267087 L494.930272,53.3131014 C494.936486,63.033311 487.061738,70.9181358 477.341528,70.9243504 C477.334029,70.9243552 477.32653,70.9243552 477.319031,70.9243505 L422.283429,70.8891891 C412.572004,70.8829846 404.700886,63.0118704 404.694677,53.3004453 L404.691873,48.9140527 C404.685658,39.1938431 412.560407,31.3090183 422.280616,31.3028036 C422.288116,31.3027988 422.295615,31.3027988 422.303114,31.3028036 Z",
    id: "Rectangle",
    fill: "#08D6A1",
    transform: "translate(449.811072, 51.113577) rotate(-30.000000) translate(-449.811072, -51.113577) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6611463,31.3378733 L101.696911,31.3027117 C111.417121,31.2965017 119.301942,39.1712542 119.308152,48.8914638 C119.308157,48.8989628 119.308157,48.9064618 119.308152,48.9139608 L119.305347,53.3003534 C119.299138,63.0117786 111.42802,70.8828927 101.716595,70.8890972 L46.6807898,70.9242585 C36.9605802,70.9304686 29.0757591,63.0557161 29.0695491,53.3355065 C29.0695442,53.327953 29.0695443,53.3203996 29.0695492,53.3128461 L29.0723944,48.9264536 C29.0786935,39.2150923 36.9497849,31.3440777 46.6611463,31.3378733 Z",
    id: "Rectangle",
    fill: "#08D6A1",
    transform: "translate(74.188769, 51.113485) rotate(30.000000) translate(-74.188769, -51.113485) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.283429,247.883657 L477.319031,247.848496 C487.039241,247.842285 494.924062,255.717038 494.930272,265.437248 C494.930276,265.444747 494.930276,265.452246 494.930272,265.459745 L494.927467,269.846137 C494.921258,279.557562 487.05014,287.428676 477.338715,287.434881 L422.303114,287.470042 C412.582904,287.476252 404.698083,279.6015 404.691873,269.88129 C404.691868,269.873791 404.691868,269.866292 404.691873,269.858793 L404.694677,265.472401 C404.700886,255.760976 412.572004,247.889861 422.283429,247.883657 Z",
    id: "Rectangle",
    fill: "#08D6A1",
    transform: "translate(449.811072, 267.659269) rotate(30.000000) translate(-449.811072, -267.659269) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,331.972421 C283.952389,331.972421 292.475936,391.678851 351.187308,268.487199 C382.797853,221.684383 407.310924,185.128345 407.310924,145.096606 C407.310924,64.9619631 342.253008,0 262,0 C181.746992,0 116.689076,64.9619631 116.689076,145.096606 C116.689076,184.504066 130.317726,217.241409 172.583431,266.763607 C224.249893,386.078748 241.370859,331.972421 262,331.972421 Z",
    id: "Oval",
    fill: "#6CE8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.05042,317.673629 L328.05042,379.229765 L326.94858,379.229629 L306.033613,421 L217.966387,421 L197.05058,379.229629 L195.94958,379.229765 L195.94958,317.673629 L328.05042,317.673629 Z",
    id: "Combined-Shape",
    fill: "#08D6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,66.4090425 C235.981808,68.6924058 216.272885,77.140208 202.873231,91.7524493 C189.473577,106.36469 183.164308,124.286354 183.945423,145.517441",
    id: "Path-17",
    stroke: "#08D6A1",
    strokeWidth: 26.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/Insights.4d987776d009d0a7f642956a27d9c021.svg";
export { ForwardRef as ReactComponent };